import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import {
    GetAllLofasFiltered_getAllLofasFiltered as Lofa,
    GetAllRegions_getAllRegions as RegionType,
} from '../../../types/schemaTypes';
import { CustomButton } from '../../_common';
import SearchableDropdown from '../../_common/SearchableDropdown/SearchableDropdown';
import { Textfield } from '../../_common/Textfield/Textfield';
import { ModalForm } from '../interface';
import './AddEditLofaModal.scss';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { GoogleMap, Polygon, Circle, Marker, useJsApiLoader } from '@react-google-maps/api';
import { geoFenceTypes } from '../../_common/Geofence/GeofenceTypes';
interface Option {
    id: number | string;
    name: string | number;
}

interface LatLng {
    lat: number;
    lng: number;
}

let lofaLat = 0;
let lofaLong = 0;
let type;
let geofenceRadius;

interface AddEditLofaModalProps {
    modalForm: ModalForm;
    options: Option[];
    selectedLofa?: Lofa;
    regions: Option[];
    regionsWithDistricts: RegionType[];
    onClickHide: () => void;
    onClickSave: (
        id: number,
        name: string,
        desc: string,
        stateId: number,
        regionId: number,
        districtId: number,
        city: string,
        utm: string,
        addr: string,
        directions: string,
        phone: string,
        jde: string,
        lat: number,
        long: number,
        entryKioskLatitude: number | null,
        entryKioskLongitude: number | null,
        entryKioskGeoFenceType: string,
        zip: string,
        geoFenceType: string,
        geoFenceRadius: number,
        polygonCoordinates: LatLng[],
        kioskGeoFenceRadius: number,
        entryKioskPolygonCoordinates: LatLng[],
    ) => void;
    show: boolean;
    errorMessage?: string;
}

const normalizeGeofenceType = (value?: string | null): string => (value || '').trim().toLowerCase();
const isCircleType = (value?: string | null): boolean => normalizeGeofenceType(value) === 'circle';
const isPolygonType = (value?: string | null): boolean => normalizeGeofenceType(value) === 'polygon';
const resolveGeofenceType = (eventKey: any): string => {
    if (eventKey == null) return '';

    const raw = String(eventKey).trim();
    const asNumber = parseInt(raw, 10);

    if (!Number.isNaN(asNumber)) {
        const byId = geoFenceTypes.find((item: Option) => item.id === asNumber);
        if (byId) return String(byId.name);
    }

    const byName = geoFenceTypes.find((item: Option) => normalizeGeofenceType(String(item.name)) === normalizeGeofenceType(raw));
    return byName ? String(byName.name) : raw;
};

const toFiniteNumber = (value: unknown, fallback = 0): number => {
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

const getRegionDistricts = (regionsList: RegionType[], regionId: number | string): Option[] => {
    const selectedRegion = regionsList.filter((item: RegionType) => item.id === regionId)[0];
    const districtsList: Option[] = [];
    if (selectedRegion && selectedRegion.districts) {
        selectedRegion.districts.forEach((element: any) => {
            if (element && element.districtName !== null) {
                districtsList.push({
                    id: element.id,
                    name: element.districtName,
                });
            }
        });
    }

    return districtsList;
};

const AddEditLofaModal = ({
    show,
    options,
    regions,
    regionsWithDistricts,
    onClickHide,
    onClickSave,
    modalForm,
    selectedLofa,
    errorMessage,
}: AddEditLofaModalProps): React.ReactElement => {
    const { isLoaded: isGoogleMapsLoaded } = useJsApiLoader({
        id: 'sbs-google-map-script',
        googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
    });

    const [selectedId, setSelectedId] = useState(0);
    const [selectedName, setSelectedName] = useState('');
    const [selectedDesc, setSelectedDesc] = useState('');
    const [selectedJDE, setSelectedJDE] = useState('');
    const [selectedAddr, setSelectedAddr] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedUtm, setSelectedUtm] = useState('');
    const [selectedLong, setSelectedLong] = useState(0);
    const [selectedGeoFenceType, setSelectedGeoFenceType] = useState('Circle');
    const [selectedKioskGeoFenceType, setSelectedKioskGeoFenceType] = useState('Circle');
    const [selectedgeoFenceRadius, setSelectedgeoFenceRadius] = useState<number | null>(null);
    const [selectedKioskGeoFenceRadius, setSelectedKioskGeoFenceRadius] = useState<number | null>(null);
    const [selectedLat, setSelectedLat] = useState(0);
    const [selectedEntryKioskLat, setSelectedEntryKioskLat] = useState<number | null>(null);
    const [selectedEntryKioskLong, setSelectedEntryKioskLong] = useState<number | null>(null);
    const [selectedDirections, setSelectedDirections] = useState('');
    const [selectedState, setSelectedState] = useState(0);
    const [selectedDistrictName, setSelectedDistrictName] = useState(0);
    const [selectedRegionName, setSelectedRegionName] = useState(0);
    const [selectedPhone, setSelectedPhone] = useState('');
    const [selectedZip, setSelectedZip] = useState('');
    const isEditForm = modalForm === ModalForm.EDIT_LOFA;
    const [formErrors, setFormErrrors]: any = React.useState({});
    const [path, setPath] = useState<LatLng[]>([]);
    const [kioskPath, setKioskPath] = useState<LatLng[]>([]);
    const [selectedPolygonCoordinates, setSelectedpolygonCoordinates] = useState<LatLng[]>([]);
    const [selectedEntryKioskPolygonCoordinates, setSelectedEntryKioskPolygonCoordinates] = useState<LatLng[]>([]);
    const [showRadius, setShowRadius] = useState(true);
    const [radius, setRadius] = useState(0);
    const [districts, setDistricts] = useState<Option[]>([]);
    const isTCSEnabled = selectedLofa?.isTCSEnabled === true;

    useEffect(() => {
            setSelectedId(selectedLofa?.id ? selectedLofa.id : 0);
            setSelectedName(selectedLofa?.lofaName ? selectedLofa.lofaName : '');
            setSelectedDesc(selectedLofa?.description ? selectedLofa.description : '');
            setSelectedState(selectedLofa?.stateId ? selectedLofa.stateId : 0);
            setSelectedRegionName(selectedLofa?.regionId ? selectedLofa.regionId : 0);
            setSelectedDistrictName(selectedLofa?.districtId ? selectedLofa.districtId : 0);
            setSelectedJDE(selectedLofa?.jdeNumber ? selectedLofa.jdeNumber : '');
            setSelectedAddr(selectedLofa?.addressStreet ? selectedLofa.addressStreet : '');
            setSelectedCity(selectedLofa?.city ? selectedLofa.city : '');
            setSelectedUtm(selectedLofa?.utm ? selectedLofa.utm : '');
            setSelectedLong(selectedLofa?.longitude ? selectedLofa.longitude : 0);
            setSelectedLat(selectedLofa?.latitude ? selectedLofa.latitude : 0);
            setSelectedEntryKioskLat(selectedLofa?.entryKioskLatitude ?? null);
            setSelectedEntryKioskLong(selectedLofa?.entryKioskLongitude ?? null);
            setSelectedDirections(selectedLofa?.directions ? selectedLofa.directions : '');
            setSelectedPhone(selectedLofa?.phoneNumber ? selectedLofa.phoneNumber : '');
            setSelectedZip(selectedLofa?.zip ? selectedLofa.zip : '');
            setSelectedGeoFenceType(selectedLofa?.geoFenceType ? selectedLofa.geoFenceType : 'Circle');
            setSelectedgeoFenceRadius(selectedLofa?.geoFenceRadius ?? null);
            setSelectedKioskGeoFenceRadius(selectedLofa?.kioskGeoFenceRadius ?? null);
            const resolvedLofaLat = toFiniteNumber(selectedLofa?.latitude, 0);
            const resolvedLofaLng = toFiniteNumber(selectedLofa?.longitude, 0);
            setPath([
                {
                    lat: resolvedLofaLat,
                    lng: resolvedLofaLng,
                },
                {
                    lat: resolvedLofaLat,
                    lng: resolvedLofaLng,
                },
            ]);
            const kioskLat = toFiniteNumber(selectedLofa?.entryKioskLatitude ?? selectedLofa?.latitude ?? lofaLat, 0);
            const kioskLng = toFiniteNumber(selectedLofa?.entryKioskLongitude ?? selectedLofa?.longitude ?? lofaLong, 0);
            setKioskPath([
                {
                    lat: kioskLat,
                    lng: kioskLng,
                },
                {
                    lat: kioskLat,
                    lng: kioskLng,
                },
            ]);
            const lofaPolygonCoords: LatLng[] = [];
            if (selectedLofa && selectedLofa.polygonCoordinates && selectedLofa.polygonCoordinates.length !== 0) {
                selectedLofa.polygonCoordinates.forEach((element): void => {
                    if (element !== null) {
                        lofaPolygonCoords.push({
                            lat: element.lat as number,
                            lng: element.lng as number,
                        });
                    }
                });
            }
            setSelectedpolygonCoordinates(lofaPolygonCoords);

            const kioskPolygonCoords: LatLng[] = [];
            const entryKioskPolygonCoordinates = selectedLofa?.entryKioskPolygonCoordinates;
            if (entryKioskPolygonCoordinates && entryKioskPolygonCoordinates.length !== 0) {
                entryKioskPolygonCoordinates.forEach((element): void => {
                    if (element !== null) {
                        kioskPolygonCoords.push({
                            lat: element.lat as number,
                            lng: element.lng as number,
                        });
                    }
                });
            }
            setSelectedEntryKioskPolygonCoordinates(kioskPolygonCoords);
            setSelectedKioskGeoFenceType(kioskPolygonCoords.length > 0 ? 'Polygon' : 'Circle');

        if (isCircleType(selectedLofa?.geoFenceType)) {
            setShowRadius(true);
        } else {
            setShowRadius(false);
        }
        setFormErrrors({});
    }, [selectedLofa]);

    useEffect(() => {
        if (selectedRegionName) {
            setDistricts(getRegionDistricts(regionsWithDistricts, +selectedRegionName));
        }
    }, [selectedRegionName]);

    const polygonRef = useRef<google.maps.Polygon | null>(null);
    const listenersRef = useRef<google.maps.MapsEventListener[]>([]);
    const kioskPolygonRef = useRef<google.maps.Polygon | null>(null);
    const kioskListenersRef = useRef<google.maps.MapsEventListener[]>([]);
    const circleRef = useRef<google.maps.Circle | null>(null);
    const kioskCircleRef = useRef<google.maps.Circle | null>(null);

    const clearState = (): void => {
        setSelectedId(0);
        setSelectedName('');
        setSelectedDesc('');
        setSelectedJDE('');
        setSelectedAddr('');
        setSelectedCity('');
        setSelectedUtm('');
        setSelectedDirections('');
        setSelectedPhone('');
        setSelectedState(0);
        setSelectedDistrictName(0);
        setSelectedRegionName(0);
        setSelectedLat(0);
        setSelectedLong(0);
        setSelectedEntryKioskLat(null);
        setSelectedEntryKioskLong(null);
        setSelectedZip('');
        setFormErrrors({});
        setSelectedGeoFenceType('Circle');
        setSelectedKioskGeoFenceType('Circle');
        setSelectedgeoFenceRadius(null);
        setSelectedKioskGeoFenceRadius(null);
        setPath([]);
        setKioskPath([]);
        setSelectedpolygonCoordinates([]);
        setSelectedEntryKioskPolygonCoordinates([]);
        setShowRadius(false);
        lofaLat = 0;
        lofaLong = 0;
        type = '';
        geofenceRadius = undefined;
    };

    const onSave = (): void => {
        const lofaRadiusToSave = selectedgeoFenceRadius ?? selectedLofa?.geoFenceRadius ?? 0;
        onClickSave(
            selectedId,
            selectedName,
            selectedDesc,
            selectedState,
            selectedRegionName,
            selectedDistrictName,
            selectedCity,
            selectedUtm,
            selectedAddr,
            selectedDirections,
            selectedPhone,
            selectedJDE,
            selectedLong,
            selectedLat,
            selectedEntryKioskLat,
            selectedEntryKioskLong,
            selectedKioskGeoFenceType,
            selectedZip,
            selectedGeoFenceType,
            lofaRadiusToSave,
            selectedPolygonCoordinates,
            selectedKioskGeoFenceRadius ?? 0,
            selectedEntryKioskPolygonCoordinates,
        );

        setSelectedDirections('');
        lofaLat = 0;
        lofaLong = 0;
        type = '';
        geofenceRadius = undefined;
        setFormErrrors({});
    };

    const onCancel = (): void => {
        clearState();
        onClickHide();
    };

    const setSaveButtonStatus = (): boolean => {
        const isNameValid = selectedName.trim().length > 2 ? true : false;
        const isStateValid = selectedState != 0 ? true : false;

        const isFormValid = isNameValid && isStateValid;

        return !isFormValid;
    };

    const changeName = (event: any): void => {
        setSelectedName(event.target.value);
    };

    const changeAddr = (event: any): void => {
        const address = event.target.value ? event.target.value : '';

        setSelectedAddr(address);
    };
    const changeCity = (event: any): void => {
        const city = event.target.value ? event.target.value : '';

        setSelectedCity(city);
    };
    const changeUtm = (event: any): void => {
        const utm = event.target.value ? event.target.value : '';

        setSelectedUtm(utm);
    };
    const changeZip = (event: any): void => {
        const zip = event.target.value ? event.target.value : '';

        setSelectedZip(zip);
    };

    const getStateName = (): string | number | null => {
        const id = selectedLofa && selectedLofa.stateId ? selectedLofa.stateId.toString() : '';

        if (id == '') return null;

        const numId = parseInt(id);
        const filteredRole = options.filter((item: Option) => item.id === numId);
        const role = filteredRole[0].name;

        return role;
    };

    const onRegionChange = (regionId: any): void => {
        setDistricts(getRegionDistricts(regionsWithDistricts, +regionId));
        const selectedRegion = regionsWithDistricts.filter((item: RegionType) => item.id === +regionId)[0];
        if (selectedRegion) {
            setSelectedRegionName(selectedRegion.id);
            setSelectedDistrictName(0)
        }
    };

    const onDistrictChange = (districtId: any): void => {
        const numId = parseInt(districtId);
        if (districts.length > 0) {
            const selectedDistrict = districts.filter((item: any) => item.id === numId);
            const districtType = parseInt(selectedDistrict[0].id.toString());
            setSelectedDistrictName(districtType);
        }
    };

    const changeGeoFenceType = (eventkey: any): void => {
        if (eventkey == '') return;

        type = resolveGeofenceType(eventkey);
        setSelectedGeoFenceType(type);
        const resolvedLofaLat = toFiniteNumber(selectedLofa?.latitude ?? lofaLat, 0);
        const resolvedLofaLng = toFiniteNumber(selectedLofa?.longitude ?? lofaLong, 0);
        setPath([
            {
                lat: resolvedLofaLat,
                lng: resolvedLofaLng,
            },
            {
                lat: resolvedLofaLat,
                lng: resolvedLofaLng,
            },
        ]);
        const lofaPolygonCoords: LatLng[] = [];
        if (selectedLofa && selectedLofa.polygonCoordinates && selectedLofa.polygonCoordinates.length !== 0) {
            selectedLofa.polygonCoordinates.forEach((element): void => {
                if (element !== null) {
                    lofaPolygonCoords.push({
                        lat: element.lat as number,
                        lng: element.lng as number,
                    });
                }
            });
            setSelectedpolygonCoordinates(lofaPolygonCoords);
        }
        if (isCircleType(type)) {
            setShowRadius(true);
            geofenceRadius = undefined;
            setSelectedgeoFenceRadius((currentRadius) => (currentRadius && currentRadius > 0 ? currentRadius : null));
        } else {
            setShowRadius(false);
            setSelectedgeoFenceRadius(selectedLofa?.geoFenceRadius ?? null);
            formErrors.Radius = '';
        }
    };

    const changeState = (value: any): void => {
        const id = parseInt(value);
        setSelectedState(id);
    };

    const changeLat = (event: any): void => {
        if (event.target.value) {
            const id = parseFloat(event.target.value);
            lofaLat = id;
            setSelectedLat(id);
            setPath([
                {
                    lat: lofaLat,
                    lng: lofaLong,
                },
                {
                    lat: lofaLat,
                    lng: lofaLong,
                },
            ]);
        }
    };
    const changeLong = (event: any): void => {
        if (event.target.value) {
            const id = parseFloat(event.target.value);
            lofaLong = id;
            setSelectedLong(id);
            setPath([
                {
                    lat: lofaLat,
                    lng: lofaLong,
                },
                {
                    lat: lofaLat,
                    lng: lofaLong,
                },
            ]);
        }
    };

    const changeEntryKioskLat = (event: any): void => {
        if (event.target.value === "") {
            setSelectedEntryKioskLat(null);
            return;
        }
        if (event.target.value) {
            const lat = parseFloat(event.target.value);
            setSelectedEntryKioskLat(lat);
            const lng = selectedEntryKioskLong ?? selectedLofa?.entryKioskLongitude ?? selectedLong ?? selectedLofa?.longitude ?? 0;
            setKioskPath([
                { lat, lng },
                { lat, lng },
            ]);
        }
    };

    const changeEntryKioskLong = (event: any): void => {
        if (event.target.value === "") {
            setSelectedEntryKioskLong(null);
            return;
        }
        if (event.target.value) {
            const lng = parseFloat(event.target.value);
            setSelectedEntryKioskLong(lng);
            const lat = selectedEntryKioskLat ?? selectedLofa?.entryKioskLatitude ?? selectedLat ?? selectedLofa?.latitude ?? 0;
            setKioskPath([
                { lat, lng },
                { lat, lng },
            ]);
        }
    };

    const changeRadius = (event: any): void => {
        if (event.target.value === "") setSelectedgeoFenceRadius(null);
        if (event.target.value) {
            const radius = parseInt(event.target.value);
            geofenceRadius = radius;
            setSelectedgeoFenceRadius(radius);
        }
    };

    const changeKioskRadius = (event: any): void => {
        if (event.target.value === "") setSelectedKioskGeoFenceRadius(null);
        if (event.target.value) {
            const kioskRadius = parseInt(event.target.value);
            setSelectedKioskGeoFenceRadius(kioskRadius);
        }
    };

    const changeKioskGeoFenceType = (eventKey: any): void => {
        if (eventKey == '') return;

        const kioskType = resolveGeofenceType(eventKey);
        setSelectedKioskGeoFenceType(kioskType);
        const lat = selectedEntryKioskLat ?? selectedLofa?.entryKioskLatitude ?? selectedLat ?? selectedLofa?.latitude ?? 0;
        const lng = selectedEntryKioskLong ?? selectedLofa?.entryKioskLongitude ?? selectedLong ?? selectedLofa?.longitude ?? 0;
        const nextKioskPath = [
            { lat, lng },
            { lat, lng },
        ];
        setKioskPath(nextKioskPath);

        if (isCircleType(kioskType)) {
            if (!selectedKioskGeoFenceRadius || selectedKioskGeoFenceRadius <= 0) {
                setSelectedKioskGeoFenceRadius(300);
            }
        } else {
            setSelectedKioskGeoFenceRadius(null);
        }

    };

    const onEdit = useCallback(() => {
        if (polygonRef.current) {
            const nextPath = polygonRef.current
                .getPath()
                .getArray()
                .map((latLng: google.maps.LatLng) => {
                    return { lat: latLng.lat(), lng: latLng.lng() };
                });
            setSelectedpolygonCoordinates(nextPath);
        }
    }, [setSelectedpolygonCoordinates]);

    const onLoad = useCallback(
        (polygon: google.maps.Polygon) => {
            polygonRef.current = polygon;
            const path = polygon.getPath();
            if (path != undefined) {
                listenersRef.current.push(
                    path.addListener('set_at', onEdit),
                    path.addListener('insert_at', onEdit),
                    path.addListener('remove_at', onEdit),
                );
            }
        },
        [onEdit],
    );

    const onKioskEdit = useCallback(() => {
        if (kioskPolygonRef.current) {
            const nextPath = kioskPolygonRef.current
                .getPath()
                .getArray()
                .map((latLng: google.maps.LatLng) => {
                    return { lat: latLng.lat(), lng: latLng.lng() };
                });
            setSelectedEntryKioskPolygonCoordinates(nextPath);
        }
    }, [setSelectedEntryKioskPolygonCoordinates]);

    const onKioskLoad = useCallback(
        (polygon: google.maps.Polygon) => {
            kioskPolygonRef.current = polygon;
            const polygonPath = polygon.getPath();
            if (polygonPath != undefined) {
                kioskListenersRef.current.push(
                    polygonPath.addListener('set_at', onKioskEdit),
                    polygonPath.addListener('insert_at', onKioskEdit),
                    polygonPath.addListener('remove_at', onKioskEdit),
                );
            }
        },
        [onKioskEdit],
    );

    const onCircleDragEnd = (e) => {
        setSelectedLat(e.latLng.lat());
        setSelectedLong(e.latLng.lng());
    };

    const changedRadius = () => {
        if (circleRef.current) {
            const currentRadius = Math.round(circleRef.current.getRadius());

            // Ignore transient zero values emitted by the map while initializing/editing.
            if (currentRadius <= 0) {
                return;
            }

            setRadius(currentRadius);
            geofenceRadius = currentRadius;
            setSelectedgeoFenceRadius(currentRadius);
        }
    };
    const onCircleLoad = useCallback(
        (circle: google.maps.Circle) => {
            circleRef.current = circle;
        },
        [changedRadius, onCircleDragEnd],
    );

    const onKioskCircleDragEnd = (e) => {
        setSelectedEntryKioskLat(e.latLng.lat());
        setSelectedEntryKioskLong(e.latLng.lng());
        setKioskPath([
            { lat: e.latLng.lat(), lng: e.latLng.lng() },
            { lat: e.latLng.lat(), lng: e.latLng.lng() },
        ]);
    };

    const changedKioskRadius = () => {
        if (selectedKioskGeoFenceRadius === null) return;

        if (kioskCircleRef.current) {
            const currentKioskRadius = kioskCircleRef.current.getRadius();
            const roundedKioskRadius = Math.round(currentKioskRadius);

            if (roundedKioskRadius <= 0) {
                return;
            }

            setSelectedKioskGeoFenceRadius(roundedKioskRadius);
        }
    };

    const onKioskCircleLoad = useCallback(
        (circle: google.maps.Circle) => {
            kioskCircleRef.current = circle;
        },
        [changedKioskRadius, onKioskCircleDragEnd, selectedKioskGeoFenceRadius],
    );

    const onUnmount = useCallback(() => {
        listenersRef.current.forEach((lis) => lis.remove());
        polygonRef.current = null;
    }, []);

    const onKioskUnmount = useCallback(() => {
        kioskListenersRef.current.forEach((lis) => lis.remove());
        kioskPolygonRef.current = null;
    }, []);

    const changeJDE = (event: any): void => {
        const jde = event.target.value ? event.target.value : '';

        setSelectedJDE(jde);
    };

    const changePhone = (event: any): void => {
        const phone = event.target.value ? event.target.value : '';

        setSelectedPhone(phone);
    };

    const handleInputChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    ): void => {
        event.persist();
        setSelectedDirections(event.target.value);
    };

    const validateDistrict:HTMLElement | null = document.getElementById('district')
    const validateForm = () => {
        const errors = {};

        if (!selectedName || (selectedLofa !== undefined && !selectedLofa.lofaName)) {
            errors['lofaName'] = 'Lofa Name is required';
        }
        if (!selectedCity || (selectedLofa !== undefined && !selectedLofa.city)) {
            errors['city'] = 'City is required';
        }
        if (!selectedState || (selectedLofa !== undefined && !selectedLofa.stateId)) {
            errors['stateId'] = 'State is required';
        }
        if (selectedRegionName == 0 || (selectedLofa !== undefined && selectedLofa.regionId == 0)) {
            errors['regionId'] = 'Region is required';
        }
        if (validateDistrict?.innerHTML==='' ||selectedDistrictName == 0 || (selectedLofa !== undefined && selectedLofa.districtId == 0)) {
            errors['districtId'] = 'District is required';
        }
        if (!selectedLat || (selectedLofa !== undefined && !selectedLofa.latitude)) {
            errors['Lat'] = 'Latitude is required';
        }
        if (!selectedLong || (selectedLofa !== undefined && !selectedLofa.longitude)) {
            errors['Long'] = 'Longitude is required';
        }
        if (!selectedGeoFenceType || (selectedLofa !== undefined && !selectedLofa.geoFenceType)) {
            errors['Type'] = 'GeoFence Type is required';
        }
        if (isCircleType(selectedGeoFenceType) && (!selectedgeoFenceRadius || selectedgeoFenceRadius === 0)) {
            errors['Radius'] = 'Radius is required';
        }
        if (isTCSEnabled) {
            if (selectedEntryKioskLat === null) {
                errors['entryKioskLat'] = 'Entry kiosk latitude is required';
            }
            if (selectedEntryKioskLong === null) {
                errors['entryKioskLong'] = 'Entry kiosk longitude is required';
            }
            if (!selectedKioskGeoFenceType) {
                errors['kioskType'] = 'Kiosk geofence type is required';
            }
            if (isCircleType(selectedKioskGeoFenceType) && (selectedKioskGeoFenceRadius === null || selectedKioskGeoFenceRadius <= 0)) {
                errors['kioskRadius'] = 'Kiosk geofence radius is required';
            }
        }
        if (isPolygonType(selectedGeoFenceType) || isPolygonType(type)) {
            if (selectedPolygonCoordinates.length < 2) {
                errors['polygonError'] = 'Please draw polyon on Map';
            }
        }
        if (isTCSEnabled && isPolygonType(selectedKioskGeoFenceType) && selectedEntryKioskPolygonCoordinates.length < 2) {
            errors['entryKioskPolygonError'] = 'Please draw polygon on Kiosk Map';
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors,
        };
    };

    const handleSaveChanges = () => {
        setFormErrrors({});
        const { isValid, errors } = validateForm();

        if (!isValid) {
            setFormErrrors(errors);
            return;
        }
        onSave();
    };
    const changeDesc = (event: any): void => {
        const dir = event.target.value ? event.target.value : '';

        setSelectedDesc(dir);
    };
    const handleMarkerMove = (event: any) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setSelectedLat(lat);
        setSelectedLong(lng);
    };

    const handleKioskMarkerMove = (event: any) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setSelectedEntryKioskLat(lat);
        setSelectedEntryKioskLong(lng);
        setKioskPath([
            { lat, lng },
            { lat, lng },
        ]);
    };

    return (
        <Modal show={show} onHide={onCancel} dialogClassName="AddEditLofaModal">
            <Modal.Header className="AddEditLofaModal-Header">
                <Modal.Title className="AddEditLofaModal-Header-Container">
                    <button className="material-icons AddEditLofaModal-X-Button" onClick={onCancel}>
                        close
                    </button>
                    <div className="AddEditLofaModal-Title">{isEditForm ? 'Edit Lofa' : 'Create New Lofa'}</div>
                    <div className="AddEditLofaModal-ErrorMessage">{errorMessage}</div>
                </Modal.Title>
            </Modal.Header>

            <Row className="AddEditLofaModal-Upper-TextField-Container">
                <Col className="AddEditLofaModal-Textfield" md={6}>
                    <Textfield
                        label="Name"
                        value={selectedLofa !== undefined ? selectedLofa.lofaName : ''}
                        onChange={(event): void => changeName(event)}
                        onBlur={() => { }}
                        error={formErrors.lofaName}
                        helperText={formErrors.lofaName}
                    />
                </Col>
                <Col className="AddEditLofaModal-Textfield" md={6}>
                    <Textfield
                        label="Description"
                        value={selectedLofa !== undefined ? selectedLofa.description : ''}
                        onChange={(event): void => changeDesc(event)}
                        onBlur={() => { }}
                    />
                </Col>
            </Row>

            <Row className="AddEditLofaModal-Upper-TextField-Container">
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="AddressStreet"
                        value={selectedLofa !== undefined ? selectedLofa.addressStreet : ''}
                        onChange={(event): void => changeAddr(event)}
                        onBlur={() => { }}
                        error={formErrors.addressStreet}
                        helperText={formErrors.addressStreet}
                    />
                </Col>
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="City"
                        value={selectedLofa !== undefined ? selectedLofa.city : ''}
                        onChange={(event): void => changeCity(event)}
                        onBlur={() => { }}
                        error={formErrors.city}
                        helperText={formErrors.city}
                    />
                </Col>
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="Zip"
                        value={selectedLofa !== undefined ? selectedLofa.zip : ''}
                        onChange={(event): void => changeZip(event)}
                        onBlur={() => { }}
                        error={formErrors.zip}
                        helperText={formErrors.zip}
                    />
                </Col>
            </Row>

            <Row className="AddEditLofaModal-Upper-TextField-Container">
                <Col className="AddEditLofaModal-Down-TextField-Container" md={4}>
                    <SearchableDropdown
                        dropdownOptions={options}
                        id="state"
                        label="State"
                        onSelect={(eventKey: string | null) => {
                            changeState(eventKey);
                        }}
                        value={getStateName()}
                        errorMessage={formErrors.stateId}
                        hasError={formErrors.stateId != undefined}
                    />
                </Col>
                <Col className="AddEditLofaModal-Down-TextField-Container" md={4}>
                    <SearchableDropdown
                        dropdownOptions={regions}
                        id="region"
                        label="Region*"
                        onSelect={(eventKey: string | null) => {
                            onRegionChange(eventKey);
                        }}
                        value={
                            (selectedLofa && selectedRegionName !== null)
                                ? regions.find((region) => region.id === selectedRegionName)?.name ?? ''
                                : ''
                        }
                        errorMessage={formErrors.regionId}
                        hasError={formErrors.regionId != undefined}
                    />
                </Col>
                <Col className="AddEditLofaModal-Down-TextField-Container" md={4}>
                    <SearchableDropdown
                        dropdownOptions={districts}
                        id="district"
                        label="District*"
                        onSelect={(eventKey: string | null) => {
                            onDistrictChange(eventKey);
                        }}
                        value={
                            (selectedDistrictName !== null)
                                ? districts.find((district) => district.id === selectedDistrictName)?.name ?? ''
                                : ''
                        }
                        errorMessage={formErrors.districtId}
                        hasError={formErrors.districtId != undefined}
                    />
                </Col>
            </Row>

            <Row className="AddEditLofaModal-Upper-TextField-Container">
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="Utm"
                        value={selectedLofa !== undefined ? selectedLofa.utm : ''}
                        onChange={(event): void => changeUtm(event)}
                        onBlur={() => { }}
                    />
                </Col>
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="PhoneNumber"
                        value={selectedLofa !== undefined ? selectedLofa.phoneNumber : ''}
                        onChange={(event): void => changePhone(event)}
                        onBlur={() => { }}
                    />
                </Col>
                <Col className="AddEditLofaModal-Textfield" md={4}>
                    <Textfield
                        label="JDENumber"
                        value={selectedLofa !== undefined ? selectedLofa.jdeNumber : ''}
                        onChange={(event): void => changeJDE(event)}
                        onBlur={() => { }}
                    />
                </Col>
            </Row>

            <div className="AddEditLofa-NotesContainer">
                <div className="AddEditLofa-NotesLabel">DIRECTIONS</div>
                <textarea
                    className="AddEditLofa-NotesParagraph"
                    name="directions"
                    rows={3}
                    value={selectedDirections}
                    onChange={(event) => {
                        handleInputChange(event);
                    }}
                />
            </div>

            <div className="AddEditLofa-GeoFencingContainer">
                <div className="AddEditLofa-NotesLabel">Geofencing</div>
                <Row className="AddEditLofaModal-Upper-TextField-Container">
                    <Col md={isTCSEnabled ? 6 : 12} className="AddEditLofaModal-Geofencing-FieldContainer">
                        <Textfield
                            label="Latitude"
                            value={selectedLat}
                            onChange={(event): void => changeLat(event)}
                            onBlur={() => { }}
                            error={formErrors.Lat}
                            helperText={formErrors.Lat}
                        />
                        <Textfield
                            label="Longitude"
                            value={selectedLong}
                            onChange={(event): void => changeLong(event)}
                            onBlur={() => { }}
                            error={formErrors.Long}
                            helperText={formErrors.Long}
                        />
                        <div className="AddEditLofaModal-Down-TextField-Container-Sm">
                            <SearchableDropdown
                                dropdownOptions={geoFenceTypes}
                                id="GeofenceType"
                                label="Geofence Type"
                                onSelect={(eventKey: string | null) => {
                                    changeGeoFenceType(eventKey);
                                }}
                                value={selectedLofa !== undefined ? selectedLofa.geoFenceType : selectedGeoFenceType}
                                required
                            />
                        </div>
                        {(showRadius || isCircleType(selectedGeoFenceType)) && (
                            <Textfield
                                label="Radius (Meters)"
                                value={selectedgeoFenceRadius}
                                onChange={(event): void => changeRadius(event)}
                                onBlur={() => { }}
                                error={formErrors.Radius}
                                helperText={formErrors.Radius}
                            />
                        )}
                    </Col>

                    {isTCSEnabled && (
                        <Col md={6} className="AddEditLofaModal-Geofencing-FieldContainer">
                            <Textfield
                                label="Entry Kiosk Latitude"
                                value={selectedEntryKioskLat ?? ''}
                                onChange={(event): void => changeEntryKioskLat(event)}
                                onBlur={() => { }}
                                error={formErrors.entryKioskLat}
                                helperText={formErrors.entryKioskLat}
                            />
                            <Textfield
                                label="Entry Kiosk Longitude"
                                value={selectedEntryKioskLong ?? ''}
                                onChange={(event): void => changeEntryKioskLong(event)}
                                onBlur={() => { }}
                                error={formErrors.entryKioskLong}
                                helperText={formErrors.entryKioskLong}
                            />
                            <div className="AddEditLofaModal-Down-TextField-Container-Sm">
                                <SearchableDropdown
                                    dropdownOptions={geoFenceTypes}
                                    id="KioskGeofenceType"
                                    label="Kiosk Geofence Type"
                                    onSelect={(eventKey: string | null) => {
                                        changeKioskGeoFenceType(eventKey);
                                    }}
                                    value={selectedKioskGeoFenceType}
                                    errorMessage={formErrors.kioskType}
                                    hasError={formErrors.kioskType != undefined}
                                    required
                                />
                            </div>
                            {isCircleType(selectedKioskGeoFenceType) && (
                                <Textfield
                                    label="Kiosk GeoFence Radius (Meters)"
                                    value={selectedKioskGeoFenceRadius ?? ''}
                                    onChange={(event): void => changeKioskRadius(event)}
                                    onBlur={() => { }}
                                    error={formErrors.kioskRadius}
                                    helperText={formErrors.kioskRadius}
                                />
                            )}
                        </Col>
                    )}
                </Row>

                {isGoogleMapsLoaded && (
                <Row className="AddEditLofaModal-Upper-TextField-Container">
                    <Col md={isTCSEnabled ? 6 : 12}>
                        <div className="GeoFenceMap-Container-Lofa">
                                <GoogleMap
                                    mapContainerClassName="GeoFence-Map-Lofa"
                                    center={{
                                        lat: toFiniteNumber(selectedLat ?? selectedLofa?.latitude ?? lofaLat, 0),
                                        lng: toFiniteNumber(selectedLong ?? selectedLofa?.longitude ?? lofaLong, 0),
                                    }}
                                    zoom={16}
                                    mapTypeId="satellite"
                                >
                                    {isPolygonType(selectedGeoFenceType) && (
                                        <Polygon
                                            editable
                                            draggable
                                            path={path}
                                            paths={selectedPolygonCoordinates}
                                            onMouseUp={onEdit}
                                            onDragEnd={onEdit}
                                            onLoad={onLoad}
                                            onUnmount={onUnmount}
                                            options={{
                                                fillColor: '#009dc7',
                                                strokeColor: '#009dc7',
                                                strokeOpacity: 0.7,
                                                fillOpacity: 0.3,
                                                strokeWeight: 2,
                                            }}
                                        />
                                    )}
                                    <Fragment>
                                        <Marker
                                            draggable
                                            onDragEnd={handleMarkerMove}
                                            position={{
                                                lat: toFiniteNumber(selectedLat ?? selectedLofa?.latitude ?? lofaLat, 0),
                                                lng: toFiniteNumber(selectedLong ?? selectedLofa?.longitude ?? lofaLong, 0),
                                            }}
                                        />
                                        {isCircleType(selectedGeoFenceType) && (
                                            <Circle
                                                draggable
                                                editable
                                                onDragEnd={(e) => onCircleDragEnd(e)}
                                                onLoad={onCircleLoad}
                                                onRadiusChanged={() => {
                                                    changedRadius();
                                                }}
                                                center={{
                                                    lat: toFiniteNumber(selectedLat ?? selectedLofa?.latitude ?? lofaLat, 0),
                                                    lng: toFiniteNumber(selectedLong ?? selectedLofa?.longitude ?? lofaLong, 0),
                                                }}
                                                radius={
                                                    geofenceRadius
                                                        ? geofenceRadius
                                                        : selectedgeoFenceRadius ?? selectedLofa?.geoFenceRadius ?? 0
                                                }
                                                options={{
                                                    fillColor: '#009dc7',
                                                    strokeColor: '#009dc7',
                                                    strokeOpacity: 0.7,
                                                    fillOpacity: 0.3,
                                                    strokeWeight: 1,
                                                }}
                                            />
                                        )}
                                    </Fragment>
                                </GoogleMap>
                        </div>
                    </Col>

                    {isTCSEnabled && (
                        <Col md={6}>
                            <div className="GeoFenceMap-Container-Lofa">
                                    <GoogleMap
                                        mapContainerClassName="GeoFence-Map-Lofa"
                                        center={{
                                            lat: toFiniteNumber(
                                                selectedEntryKioskLat ?? selectedLofa?.entryKioskLatitude ?? selectedLat ?? selectedLofa?.latitude,
                                                0,
                                            ),
                                            lng: toFiniteNumber(
                                                selectedEntryKioskLong ?? selectedLofa?.entryKioskLongitude ?? selectedLong ?? selectedLofa?.longitude,
                                                0,
                                            ),
                                        }}
                                        zoom={16}
                                        mapTypeId="satellite"
                                    >
                                        <Marker
                                            draggable
                                            onDragEnd={handleKioskMarkerMove}
                                            position={{
                                                lat: toFiniteNumber(
                                                    selectedEntryKioskLat ?? selectedLofa?.entryKioskLatitude ?? selectedLat ?? selectedLofa?.latitude,
                                                    0,
                                                ),
                                                lng: toFiniteNumber(
                                                    selectedEntryKioskLong ?? selectedLofa?.entryKioskLongitude ?? selectedLong ?? selectedLofa?.longitude,
                                                    0,
                                                ),
                                            }}
                                        />
                                        {isCircleType(selectedKioskGeoFenceType) && (
                                            <Circle
                                                draggable
                                                editable
                                                onDragEnd={(e) => onKioskCircleDragEnd(e)}
                                                onLoad={onKioskCircleLoad}
                                                onRadiusChanged={() => {
                                                    changedKioskRadius();
                                                }}
                                                center={{
                                                    lat: toFiniteNumber(
                                                        selectedEntryKioskLat ?? selectedLofa?.entryKioskLatitude ?? selectedLat ?? selectedLofa?.latitude,
                                                        0,
                                                    ),
                                                    lng: toFiniteNumber(
                                                        selectedEntryKioskLong ?? selectedLofa?.entryKioskLongitude ?? selectedLong ?? selectedLofa?.longitude,
                                                        0,
                                                    ),
                                                }}
                                                radius={
                                                    selectedKioskGeoFenceRadius !== null
                                                        ? selectedKioskGeoFenceRadius
                                                        : selectedLofa?.kioskGeoFenceRadius ?? 0
                                                }
                                                options={{
                                                    fillColor: '#009dc7',
                                                    strokeColor: '#009dc7',
                                                    strokeOpacity: 0.7,
                                                    fillOpacity: 0.3,
                                                    strokeWeight: 1,
                                                }}
                                            />
                                        )}
                                        {isPolygonType(selectedKioskGeoFenceType) && (
                                            <Polygon
                                                editable
                                                draggable
                                                path={kioskPath}
                                                paths={selectedEntryKioskPolygonCoordinates}
                                                onMouseUp={onKioskEdit}
                                                onDragEnd={onKioskEdit}
                                                onLoad={onKioskLoad}
                                                onUnmount={onKioskUnmount}
                                                options={{
                                                    fillColor: '#00b894',
                                                    strokeColor: '#00b894',
                                                    strokeOpacity: 0.7,
                                                    fillOpacity: 0.25,
                                                    strokeWeight: 2,
                                                }}
                                            />
                                        )}
                                    </GoogleMap>
                                    <span className="Polygon-Error">{formErrors.entryKioskPolygonError}</span>
                            </div>
                        </Col>
                    )}
                </Row>
                )}

                <span className="Polygon-Error">{formErrors.polygonError}</span>
            </div>

            <Modal.Footer className="AddEditLofaModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton
                    title="Save"
                    onClick={handleSaveChanges}
                />
            </Modal.Footer>
        </Modal >
    );
};

export default AddEditLofaModal;

